var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15l-8.8 5-2.2-1.25v-10L13.1 5l2.2 1.25 2.2 1.25V15z",
    fill: "#DEB06A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 10v10m0-10L6.5 8.75M8.7 10l1.65-.938 4.125-2.343.825-.469M8.7 20l8.8-5V7.5l-2.2-1.25M8.7 20l-2.2-1.25v-10m0 0L13.1 5l2.2 1.25",
    stroke: "#141414",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.145 12.063l4.125-2.344M11.145 14.063l4.125-2.344M11.145 16.063l4.125-2.344",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var MemoSvgFile = /*#__PURE__*/React.memo(SvgFile);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjUgMTVMOC43IDIwTDYuNSAxOC43NVY4Ljc1TDEzLjEgNUwxNS4zIDYuMjVMMTcuNSA3LjVWMTVaIiBmaWxsPSIjREVCMDZBIi8+CjxwYXRoIGQ9Ik04LjcgMTBWMjBNOC43IDEwTDYuNSA4Ljc1TTguNyAxMEwxMC4zNSA5LjA2MjVMMTQuNDc1IDYuNzE4NzVMMTUuMyA2LjI1TTguNyAyMEwxNy41IDE1VjcuNUwxNS4zIDYuMjVNOC43IDIwTDYuNSAxOC43NVY4Ljc1TTYuNSA4Ljc1TDEzLjEgNUwxNS4zIDYuMjUiIHN0cm9rZT0iIzE0MTQxNCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTEuMTQ0NSAxMi4wNjI1TDE1LjI2OTUgOS43MTg3NSIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTExLjE0NDUgMTQuMDYyNUwxNS4yNjk1IDExLjcxODgiIHN0cm9rZT0iIzE0MTQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMS4xNDQ1IDE2LjA2MjVMMTUuMjY5NSAxMy43MTg4IiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { MemoSvgFile as ReactComponent };